import React from 'react'
import PropTypes from 'prop-types'
import { Form, FormGroup, FormControl } from 'react-bootstrap'
import { inject, observer } from "mobx-react"

@inject("store")
@observer
export default class TextField extends React.Component {
  render() {
    const { field, store } = this.props
    const { name, placeholder, uuid, hint, required } = field
    const instance = this.props.instance || 0
    const value = store.valueFor(uuid, "text", instance)
    const errorMessage = store.errorFor(uuid, "text", instance)

    return (
      <FormGroup>
        <Form.Label htmlFor={`${uuid}-${instance}`}>{ required ? "*" : "" } {name}</Form.Label>
        <div className="only-pdf">
          { value }
        </div>
        <div className="no-pdf">
          <FormControl
            id={`${uuid}-${instance}`}
            type="text"
            placeholder={placeholder}
            value={value}
            onChange={e => store.setValueFor(uuid, "text", instance, e.target.value)}
            disabled={!store.editable}
            isInvalid={!!errorMessage}
          />
        </div>
        { errorMessage && <Form.Control.Feedback type="invalid" style={{display: "block"}}>{errorMessage}</Form.Control.Feedback> }
        { hint && <Form.Text muted>{hint}</Form.Text > }
      </FormGroup>
    )
  }
}
